var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1739_25105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0175781 15.3664V9.26173C0.0175781 8.78009 0.419709 8.38965 0.915773 8.38965C1.41184 8.38965 1.81397 8.78009 1.81397 9.26173V15.3664C1.81397 15.5977 1.90862 15.8195 2.07706 15.983C2.24551 16.1466 2.47397 16.2385 2.71219 16.2385H15.287C15.5252 16.2385 15.7537 16.1466 15.9221 15.983C16.0906 15.8195 16.1852 15.5977 16.1852 15.3664V9.26173C16.1852 8.78009 16.5874 8.38965 17.0834 8.38965C17.5795 8.38965 17.9816 8.78009 17.9816 9.26173V15.3664C17.9816 16.0603 17.6977 16.7257 17.1924 17.2164C16.6871 17.707 16.0017 17.9827 15.287 17.9827H2.71219C1.99754 17.9827 1.31214 17.707 0.806804 17.2164C0.301466 16.7257 0.0175781 16.0603 0.0175781 15.3664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67325 8.65274C5.01967 8.30799 5.58833 8.30117 5.9434 8.63751L8.99879 11.5317L12.0542 8.63751C12.4093 8.30117 12.9779 8.30799 13.3243 8.65274C13.6708 8.99749 13.6637 9.54962 13.3087 9.88597L9.62605 13.3743C9.27716 13.7048 8.72047 13.7048 8.37158 13.3743L4.68894 9.88597C4.33386 9.54962 4.32684 8.99749 4.67325 8.65274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10156 10.9187V0.889663C8.10156 0.408019 8.50369 0.0175781 8.99976 0.0175781C9.49582 0.0175781 9.89795 0.408019 9.89795 0.889663V10.9187C9.89795 11.4004 9.49582 11.7908 8.99976 11.7908C8.50369 11.7908 8.10156 11.4004 8.10156 10.9187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1739_25105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTemplate);
export default __webpack_public_path__ + "static/media/download_template.52caf93ced3209eb65566c8926956bc0.svg";
export { ForwardRef as ReactComponent };